module.exports = __webpack_public_path__ + "media/bootstrap-icons/stop-df50b77a.svg";